import AGREEMENT from '../../../api/agreement';
import * as helpers from '../../components/helpers/Helpers';
import { TAX_FREE_TYPE_1_12 } from '../../constants/crm';
import router from '../../router';
import * as CONSTANTS from './../../constants/agreement';
import auth from './auth';

// Tax Deductible Amount Types
export const TAX_DEDUCTIBLE_AMOUNT_TYPES = {
  STANDARD: 0,
  INCREASED: 1,
  NONE: 2,
  STANDARD_WITH_COPYRIGHT: 3,
  INCREASED_WITH_COPYRIGHT: 4,
};

const getBaseDeduction = () => {
  return {
    'parent': '',
    'agreements': [],
    'single': false,
    'label': '',
    'deduction': '',
    'start_date': null,
    'end_date': null,
    'original': 0,
    'editor': 0,
    'creator': 0,
    'is_active': 0,
    'created_at': '',
    'updated_at': '',
    'deleted_at': null,
  };
};
const getBaseAgreement = () => {
  return {
    conclusion_location: '',
    type: {},
    number: {
      number: '',
    },
    employee: {},
    employee_original: null,
    deductions: [],
    start_date: '',
    end_date: '',
    termination_date: '',
    tax_deductible_amount_type: 0,
    agreement_concluded_with_own_employee: false,
    tax_deductible_amount: '',
    min_gross_salary: 0,
    gross_salary: '',
    hour_salary_day: '',
    hour_salary_night: '',
    hour_salary_other: '',
    workplace: '',
    job_position: '',
    payment_deadline_type: 1,
    payment_deadline_day: '10',
    payment_deadline_month: 1,
    company_representative: '',
    duties_description: '',
    insurance_title_code: '',
    retirement_entitlement: '',
    salary_type: CONSTANTS.AGREEMENT.SALARY_TYPE.HOURS_SALARY,
    disability_level: '',
    health_insurance_code: '',
    insurance_obligation_date: '',
    conclusion_date: '',
    working_hours: '',
    retirement_insurance: 0,
    health_insurance: 0,
    pension_insurance: 0,
    sickness_insurance: 0,
    accident_insurance: 0,
    fgsp: 0,
    fp: 0,
    has_ppk: 0,
    //checkbox that fill data for duties_description - doesnt exist in db
    attachment: false,

    pit_2: '',
    pit_2_before_first_payment: '',
    tax_free_type: TAX_FREE_TYPE_1_12,
    is_declaration_no_middle_class_relief: '',
    do_not_include_in_advance_transfer: false,
    spouse_taxation: '',
    comeback_relief: false,
    parent_relief: false,
    retirement_relief: false,
    is_contract_declaration_tax_free_amount_not_exceeded: '',
    studentstatusperiod: [],
    annex_to_agreement_id: null,
    annex_original_id: null,
    annex_start_date: null,
    annex_sign_date: null,
  };
};
const baseBoolOptions = [
  { id: 1, label: 'Tak' },
  { id: 0, label: 'Nie' },
];
const baseTaxDeductibleExpenses = [
  { id: 1, label: '20%' },
  { id: 2, label: '50%' },
];

const payment_deadline_type_base = [
  { id: CONSTANTS.AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ARREARS, label: 'Z dołu' },
  { id: CONSTANTS.AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ADVANCE, label: 'Z góry' },
  { id: CONSTANTS.AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ARREARS_END_OF_MONTH, label: 'Z dołu na koniec miesiąca' },
];

const state = {
  agreement: getBaseAgreement(),
  types: [],
  paymentDeductions: [],
  payment_deadline_type_options: [
    ...payment_deadline_type_base,
    { id: CONSTANTS.AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.BASED_ON_BILL_ISSUE_DATE, label: 'Na podstawie daty wystawienia rachunku' },
  ],
  employment_payment_deadline_type_options: [
    ...payment_deadline_type_base,
  ],

  payment_deadline_month_options: [
    { id: 1, label: 'następnego miesiąca' },
    { id: 2, label: 'danego miesiąca' },
  ],

  work_contract_tax_deductible_expenses_options: baseTaxDeductibleExpenses,
  mandate_contract_tax_deductible_amount_type_options: baseTaxDeductibleExpenses,
  employment_contract_tax_deductible_amount_type_options: [
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.STANDARD, label: 'standardowe' },
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.INCREASED, label: 'podwyższone' },
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.STANDARD_WITH_COPYRIGHT, label: 'standardowe + autorskie' }, //2 zablokowane przez appointment_contract_tax_deductible_amount_type_options i na backendzie mamy if'y z tym
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.INCREASED_WITH_COPYRIGHT, label: 'podwyższone + autorskie' },
  ],
  appointment_contract_tax_deductible_amount_type_options: [
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.STANDARD, label: 'standardowe' },
    { id: TAX_DEDUCTIBLE_AMOUNT_TYPES.NONE, label: 'brak' },
  ],
  mandate_work_contract_tax_deductible_amount_type_options: [
    { id: 0, label: '20%' },
    { id: 1, label: '50%' },
  ],

  salary_type_options: [
    { id: CONSTANTS.AGREEMENT.SALARY_TYPE.CONTRACT_SALARY, label: 'za zlecenie/dzieło' },
    { id: CONSTANTS.AGREEMENT.SALARY_TYPE.HOURS_SALARY, label: 'system godzinowy' },
    { id: CONSTANTS.AGREEMENT.SALARY_TYPE.DIFFERENT_HOURS_SALARIES, label: 'system godzinowy różne stawki (dzienna/nocna/inna)' },
  ],

  deduction: getBaseDeduction(),

  default_non_recurring_payment_deadline_day: 7,
  default_recurring_payment_deadline_day: 10,
  min_gross_salary_options: baseBoolOptions,
  insurance_title_code_options: [],
  retirement_entitlement_options: [],
  disability_level_options: [],
  health_insurance_options: [],
};

const getters = {
  getAgreementLabelByType(state) {
    return (id) => {
      if (state.types.length === 0) {
        throw new TypeError('State.types is empty. Fetch types in order to get label.');
      }
      let typeObj = state.types.find((el) => {
        return el.id === id;
      });

      return {
        prefix: typeObj.prefix,
        color: helpers.methods.getAgreementColorByPrefix(typeObj.prefix),
      };
    };
  },

  getAgreementNamesByType(state) {
    return (id) => {
      if (state.types.length === 0) {
        throw new TypeError('State.types is empty. Fetch types in order to get label.');
      }
      let typeObj = state.types.find((el) => {
        return el.id === id;
      });

      return {
        prefix: typeObj.prefix,
        name: helpers.methods.getAgreementNamesByPrefix(typeObj.prefix),
      };
    };
  },

  getComponentNameByAgreementTypeId() {
    return (id) => {
      switch (id) {
        case 1:
          return 'mandate_contract';
        case 2:
          return 'work_contract';
        case 3:
          return 'employment_contract';
        case 4:
          return 'trial_period_contract';
        case 5:
          return 'replacement_contract';
        case 6:
          return 'appointment_contract';
      }
    };
  },
};

const actions = {
  index({ commit, dispatch, state }, url) {
    return new Promise((resolve, reject) => {
      AGREEMENT.index(url).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  indexEmploymentContractAgreements({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.indexEmploymentContractAgreements().then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showAgreement({ commit, dispatch, state }, id) {
    // commit('LOADER/setLoading', true, {root: true});
    return new Promise((resolve, reject) => {
      AGREEMENT.show(id).then(response => {
        dispatch('clearAgreement');
        commit('setAgreement', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        // commit('LOADER/setLoading', false, {root: true});
      });
    });
  },
  storeAgreement({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.store(state.agreement).then(response => {
        // commit('setAgreement', response.data);
        router.push({ name: 'agreements' })['catch'](function () {});
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateAgreement({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.update(state.agreement).then(response => {
        // commit('setAgreement', response.data);
        router.push({ name: 'agreements' })['catch'](function () {});
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  destroyAgreement({ commit, dispatch }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.destroy(id).then(response => {
        // dispatch('indexAddresses');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  setTerminationDate({ commit, dispatch, state }, agreement) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.setTerminationDate(agreement).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  setInsurances({ commit }, value) {
    commit('setInsurances', value);
  },
  clearAgreement({ commit }) {
    commit('clearAgreement');
  },
  // NUMBERS
  generateNumber({ commit, dispatch, state }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.NUMBER.generate(payload).then(response => {
        commit('setNumber', response.data.number);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexTypes({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      AGREEMENT.TYPES.index().then(response => {
        commit('setTypes', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  indexInsuranceTitleCodeOptions({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.CODES.indexInsuranceTitleCodeOptions().then(response => {
        commit('setInsuranceTitleCodeOptions', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexRetirementEntitlementCodes({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.CODES.indexRetirementEntitlementCodes().then(response => {
        commit('setRetirementEntitlementCodes', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexDisabilityLevelCodes({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.CODES.indexDisabilityLevelCodes().then(response => {
        commit('setDisabilityLevelCodes', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexHealthInsuranceCodes({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.CODES.indexHealthInsuranceCodes().then(response => {
        commit('setHealthInsuranceCodes', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  prepareDefaultFields({ commit }) {
    let boss = auth.state.boss;
    if (Object.keys(boss).length > 0 && boss.constructor === Object) {
      commit('setWorkplace', boss.personaddress.residence_address.city + ' ' + boss.personaddress.residence_address.street);
      commit('setCompanyRepresentative', boss.name + ' ' + boss.surname);
    }
  },

  getTaxDeductibleAmount({ commit }, payload) {
    // commit('LOADER/setLoading', true, {root: true});
    return new Promise((resolve, reject) => {
      AGREEMENT.getTaxDeductibleAmount(payload).then(response => {
        commit('setTaxDeductibleAmount', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        // commit('LOADER/setLoading', false, {root: true});
      });
    });
  },
  getVersions({ commit }, original) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.getVersions(original).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  // ------------------DEDUCTIONS-------------------------------
  indexDeductions({ commit, dispatch, state }, url) {
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.index(url).then(response => {
        commit('setPaymentDeductions', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  indexAgreementDeductionsForPayment({ commit, dispatch, state }, payment) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.indexAgreementDeductionsForPayment(payment).then(response => {
        commit('setPaymentDeductions', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  indexDeductionsByPeriod({ commit, dispatch, state }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.indexByPeriod(payload).then(response => {
        commit('setPaymentDeductions', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  storeDeduction({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.store(state.deduction).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateDeduction({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.update(state.deduction).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showDeduction({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.DEDUCTIONS.show(id).then(response => {
        commit('setDeduction', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  storeAgreementAnnex({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.storeAnnex({ annex: state.agreement, id }).then(response => {
        // commit('setAgreement', response.data);
        router.push({ name: 'agreements' })['catch'](function () {});
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  updateAgreementAnnex({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.updateAgreementAnnex(state.agreement).then(response => {
        // commit('setAgreement', response.data);
        router.push({ name: 'agreements' })['catch'](function () {});
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  destroyAgreementAnnex({ commit, dispatch }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.destroyAgreementAnnex(id).then(response => {
        // dispatch('indexAddresses');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
};

const mutations = {
  setAgreements(state, agreements) {
    state.agreements = agreements;
  },
  setAgreement(state, agreement) {
    agreement.retirement_insurance = parseInt(agreement.retirement_insurance);
    agreement.pension_insurance = parseInt(agreement.pension_insurance);
    agreement.sickness_insurance = parseInt(agreement.sickness_insurance);
    agreement.accident_insurance = parseInt(agreement.accident_insurance);
    agreement.fp = parseInt(agreement.fp);
    agreement.fgsp = parseInt(agreement.fgsp);
    agreement.health_insurance = parseInt(agreement.health_insurance);
    agreement.type = state.types.find(el => {
      return el.id == agreement.type;
    });
    agreement.tax_deductible_amount = 0;
    agreement.attachment = false;
    state.agreement = agreement;
  },
  clearAgreement(state) {
    state.agreement = getBaseAgreement();
  },
  setInsurances(state, value) {
    // value is true only for employment, replacement and trial contract
    if (value || !state.agreement.id) {
      state.agreement.retirement_insurance = value;
      state.agreement.pension_insurance = value;
      state.agreement.sickness_insurance = value;
      state.agreement.accident_insurance = value;
      state.agreement.health_insurance = value;
      state.agreement.fp = value;
      state.agreement.fgsp = value;
    }
  },
  setType(state, type) {
    state.agreement.type = type;
  },
  setNumber(state, number) {
    state.agreement.number = number;
  },
  setNumberNumber(state, number) {
    state.agreement.number.number = number;
  },
  setTypes(state, types) {
    state.types = types;
  },
  setConclusionLocation(state, conclusion_location) {
    state.agreement.conclusion_location = conclusion_location;
  },
  setEmployee(state, employee) {
    state.agreement.employee = employee;
    state.agreement.employee_original = employee.original;
  },
  setStartDate(state, start_date) {
    state.agreement.start_date = start_date;
  },
  setAnnexStartDate(state, annex_start_date) {
    state.agreement.annex_start_date = annex_start_date;
  },
  setAnnexSignDate(state, annex_sign_date) {
    state.agreement.annex_sign_date = annex_sign_date;
  },
  setEndDate(state, end_date) {
    state.agreement.end_date = end_date;
  },
  setTerminationDate(state, termination_date) {
    state.agreement.termination_date = termination_date;
  },
  setTaxDeductibleAmountType(state, tax_deductible_amount_type) {
    state.agreement.tax_deductible_amount_type = tax_deductible_amount_type;
  },
  setAgreementConcludedWithOwnEmployee(state, agreement_concluded_with_own_employee) {
    state.agreement.agreement_concluded_with_own_employee = agreement_concluded_with_own_employee;
  },
  setTaxDeductibleAmount(state, tax_deductible_amount) {
    state.agreement.tax_deductible_amount = tax_deductible_amount;
  },
  setMinGrossSalary(state, min_gross_salary) {
    state.agreement.min_gross_salary = min_gross_salary;
  },
  setGrossSalary(state, gross_salary) {
    state.agreement.gross_salary = gross_salary;
  },
  setHourSalaryDay(state, hour_salary_day) {
    state.agreement.hour_salary_day = hour_salary_day;
  },
  setHourSalaryNight(state, hour_salary_night) {
    state.agreement.hour_salary_night = hour_salary_night;
  },
  setHourSalaryOther(state, hour_salary_other) {
    state.agreement.hour_salary_other = hour_salary_other;
  },
  setWorkplace(state, workplace) {
    state.agreement.workplace = workplace;
  },
  setJobPosition(state, job_position) {
    state.agreement.job_position = job_position;
  },
  setPaymentDeadlineType(state, payment_deadline_type) {
    state.agreement.payment_deadline_type = payment_deadline_type;
  },
  setPensionInsurance(state, pension_insurance) {
    state.agreement.pension_insurance = pension_insurance;
  },
  setPaymentDeadlineDay(state, payment_deadline_day) {
    state.agreement.payment_deadline_day = payment_deadline_day;
  },
  setPaymentDeadlineMonth(state, payment_deadline_month) {
    state.agreement.payment_deadline_month = payment_deadline_month;
  },
  setCompanyRepresentative(state, company_representative) {
    state.agreement.company_representative = company_representative;
  },
  setDutiesDescription(state, duties_description) {
    state.agreement.duties_description = duties_description;
  },
  setInsuranceTitleCode(state, insurance_title_code) {
    state.agreement.insurance_title_code = insurance_title_code;
  },
  setRetirementEntitlement(state, retirement_entitlement) {
    state.agreement.retirement_entitlement = retirement_entitlement;
  },
  setDisabilityLevel(state, disability_level) {
    state.agreement.disability_level = disability_level;
  },
  setHealthInsurance(state, health_insurance) {
    state.agreement.health_insurance = health_insurance;
  },
  setHealthInsuranceCode(state, health_insurance_code) {
    state.agreement.health_insurance_code = health_insurance_code;
  },
  setSicknessInsurance(state, sickness_insurance) {
    state.agreement.sickness_insurance = sickness_insurance;
  },
  setInsuranceObligationDate(state, insurance_obligation_date) {
    state.agreement.insurance_obligation_date = insurance_obligation_date;
  },
  setWorkingHours(state, working_hours) {
    state.agreement.working_hours = working_hours;
  },
  setRetirementInsurance(state, retirement_insurance) {
    state.agreement.retirement_insurance = retirement_insurance;
  },
  setDisabilityInsurance(state, disability_insurance) {
    state.agreement.disability_insurance = disability_insurance;
  },
  setMedicalInsurance(state, medical_insurance) {
    state.agreement.medical_insurance = medical_insurance;
  },
  setAccidentInsurance(state, accident_insurance) {
    state.agreement.accident_insurance = accident_insurance;
  },
  setFp(state, fp) {
    state.agreement.fp = fp;
  },
  setFgsp(state, fgsp) {
    state.agreement.fgsp = fgsp;
  },
  setHasPpk(state, value) {
    state.agreement.has_ppk = value;
  },
  setComebackRelief(state, comeback_relief) {
    state.agreement.comeback_relief = comeback_relief;
  },
  setParentRelief(state, parent_relief) {
    state.agreement.parent_relief = parent_relief;
  },
  setPensionRelief(state, retirement_relief) {
    state.agreement.retirement_relief = retirement_relief;
  },
  setConclusionDate(state, conclusion_date) {
    state.agreement.conclusion_date = conclusion_date;
  },
  setSalaryType(state, salary_type) {
    state.agreement.salary_type = salary_type;
  },
  setAttachment(state, attachment) {
    state.agreement.attachment = attachment;
  },
  clearAttachment(state) {
    state.agreement.attachment = false;
  },
  setInsuranceTitleCodeOptions(state, insurance_title_code_options) {
    state.insurance_title_code_options = [];
    for (var key of Object.keys(insurance_title_code_options)) {
      state.insurance_title_code_options.push({
        id: key,
        label: insurance_title_code_options[key],
      });
    }
  },
  setRetirementEntitlementCodes(state, retirement_entitlement_options) {
    state.retirement_entitlement_options = [];
    for (var key of Object.keys(retirement_entitlement_options)) {
      state.retirement_entitlement_options.push({
        id: key,
        label: retirement_entitlement_options[key],
      });
    }
  },
  setDisabilityLevelCodes(state, disability_level_options) {
    state.disability_level_options = [];
    for (var key of Object.keys(disability_level_options)) {
      state.disability_level_options.push({
        id: key,
        label: disability_level_options[key],
      });
    }
  },
  setHealthInsuranceCodes(state, health_insurance_options) {
    state.health_insurance_options = [];
    for (var key of Object.keys(health_insurance_options)) {
      state.health_insurance_options.push({
        id: key,
        label: health_insurance_options[key],
      });
    }
  },


  // ----------DEDUCTION------------
  setDeduction(state, deduction) {
    state.deduction = { ...deduction };
  },
  setPaymentDeductions(state, deductions) {
    state.paymentDeductions = [];
    for (let key in deductions) {
      if (deductions.hasOwnProperty(key) && Number.isInteger(parseInt(key))) {
        state.paymentDeductions.push(deductions[key]);
      }
    }
  },
  clearDeduction(state) {
    state.deduction = getBaseDeduction();
  },
  setLabel(state, label) {
    state.deduction.label = label;
  },
  setDeductionDeduction(state, deduction) {
    state.deduction.deduction = deduction;
  },
  setDeductionStartDate(state, start_date) {
    state.deduction.start_date = start_date;
  },
  setDeductionEndDate(state, label) {
    state.deduction.end_date = label;
  },
  setDeductionAgreements(state, agreements) {
    state.deduction.agreements = agreements;
  },
  setSingle(state, single) {
    state.deduction.single = single;
  },
  assignDeductions(state, deductions) {
    state.agreement.deductions = deductions.map(el => {
      return { id: el };
    });
  },
  setPit2(state, pit_2) {
    state.agreement.pit_2 = pit_2;
  },
  setPit2BeforeFirstPayment(state, pit_2_before_first_payment) {
    state.agreement.pit_2_before_first_payment = pit_2_before_first_payment;
  },
  setTaxFreeType(state, tax_free_type) {
    state.agreement.tax_free_type = tax_free_type;
  },
  setIsDeclarationNoMiddleClassRelief(state, is_declaration_no_middle_class_relief) {
    state.agreement.is_declaration_no_middle_class_relief = is_declaration_no_middle_class_relief;
  },
  setDoNotIncludeInAdvanceTransfer(state, do_not_include_in_advance_transfer) {
    state.agreement.do_not_include_in_advance_transfer = do_not_include_in_advance_transfer;
  },
  setSpouseTaxation(state, spouse_taxation) {
    state.agreement.spouse_taxation = spouse_taxation;
  },
  setIsContractDeclarationTaxFreeAmountNotExceeded(state, is_contract_declaration_tax_free_amount_not_exceeded) {
    state.agreement.is_contract_declaration_tax_free_amount_not_exceeded = is_contract_declaration_tax_free_amount_not_exceeded;
  },
  setStudentStatusPeriod(state, studentstatusperiod) {
    state.agreement.studentstatusperiod = studentstatusperiod;
    state.agreement.studentstatusperiod.agreement_original = studentstatusperiod.agreement_original;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
